module.exports = __webpack_public_path__ + "img/pride-day-light-medium.fbaa7b54.svg";